// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BarChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BarChartIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h13v-1.5H4.5z" />
      <path d="M12.125 3h-1.75v11h1.75z" />
      <path d="M8.25 5H6.5v9h1.75z" />
      <path d="M14.25 7H16v7h-1.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BarChartIcon = /* @__PURE__ */ Object.assign(
  BarChartIconComponent,
  { displayName: 'BarChartIcon' },
);
